import { Component } from '@angular/core';
import { ItemsListRowItemBase } from '../../components/items-list/list-row/list-row-item/list-row-item-base';

@Component({
    selector: 'fi-choose-users-list-item-full-contact-value',
    templateUrl: './choose-users-list-item-full-contact-value.component.html',
    styleUrls: ['./choose-users-list-item-full-contact-value.component.scss'],
    standalone: false,
})
export class ChooseUsersListItemFullContactValueComponent extends ItemsListRowItemBase {}
